(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:cart:lines-update', event => {
    if (event.action !== 'add') return;
    const buttons = [...document.querySelectorAll('add-to-cart-component button[data-added="true"]')];
    event.promise?.then(({ detail }) => {
      buttons.forEach(button => {
        button.removeAttribute('data-added');
        if (detail?.didError) return;
        button.setAttribute('data-cart-success', '');
        setTimeout(() => button.removeAttribute('data-cart-success'), 1600);
      });
    }).catch(() => buttons.forEach(button => button.removeAttribute('data-added')));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["muse-benefits"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('muse-usp-carousel')) {
    customElements.define('muse-usp-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-usp-track]');
        this.slides = [...this.track.children];
        this.dots = [...this.querySelectorAll('[data-usp-dot]')];
        this.index = 0;
        if (!matchMedia('(max-width: 749px)').matches || this.slides.length < 2) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => { this.show(index); this.schedule(); }, options));
        let gesture;
        this.track.addEventListener('touchstart', event => {
          if (event.touches.length !== 1) { gesture = null; return; }
          const touch = event.touches[0];
          gesture = { id: touch.identifier, x: touch.clientX, y: touch.clientY, lastX: touch.clientX, axis: null };
          clearTimeout(this.timer);
        }, { ...options, passive: true });
        this.track.addEventListener('touchmove', event => {
          if (!gesture || event.touches.length !== 1) return;
          const touch = event.touches[0];
          if (touch.identifier !== gesture.id) return;
          const dx = touch.clientX - gesture.x;
          const dy = touch.clientY - gesture.y;
          if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 8) gesture.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (gesture.axis !== 'x') return;
          if (event.cancelable) event.preventDefault();
          gesture.lastX = touch.clientX;
        }, { ...options, passive: false });
        const finish = (event, cancelled) => {
          if (!gesture) return;
          const touch = [...event.changedTouches].find(item => item.identifier === gesture.id);
          const dx = (touch?.clientX ?? gesture.lastX) - gesture.x;
          if (!cancelled && gesture.axis === 'x' && Math.abs(dx) >= 35) this.show(this.index + (dx < 0 ? 1 : -1));
          gesture = null;
          this.schedule();
        };
        this.track.addEventListener('touchend', event => finish(event, false), options);
        this.track.addEventListener('touchcancel', event => finish(event, true), options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, { threshold: 0.35 });
        this.observer.observe(this);
        this.show(0);
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
        this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === this.index)));
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.reducedMotion || !this.visible || document.hidden) return;
        this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, 2000);
      }
      disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
